import Promise from 'promise-polyfill'

if (!window.Promise) {
  window.Promise = Promise
}

if (!window.Promise.prototype.delay) {
  window.Promise.prototype.delay = function delay(duration) {
    return this.then(
      value =>
        new Promise(resolve => {
          setTimeout(() => {
            resolve(value)
          }, duration)
        }),
      reason =>
        new Promise((resolve, reject) => {
          setTimeout(() => {
            reject(reason)
          }, duration)
        })
    )
  }
}
